import script from "./KnowledgeBase.vue?vue&type=script&setup=true&lang=js"
export * from "./KnowledgeBase.vue?vue&type=script&setup=true&lang=js"

import "./KnowledgeBase.vue?vue&type=style&index=0&id=bcab398c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bcab398c"]])

export default __exports__